import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import CreateDraft from "./pages/CreateDraft";
import JoinDraft from "./pages/JoinDraft";
import DraftRoom from "./pages/DraftRoom";
import Help from "./pages/Help";
import CreateContest from "./pages/CreateContest";
import JoinContest from "./pages/JoinContest";
import ContestLobby from "./pages/ContestLobby";
import ContestStandings from "./pages/ContestStandings";
import Login from "./pages/Login";
import AuthVerify from "./pages/AuthVerify";
import Sso from "./pages/Sso";
import MyContests from "./pages/MyContests";
import RequireAuth from "./components/RequireAuth";
import InstallPrompt from "./components/InstallPrompt";
import "@/lib/authApi"; // installs axios interceptors on import

function App() {
  return (
    <div className="App font-sans text-pbo-ink">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/create" element={<CreateDraft />} />
          <Route path="/join" element={<JoinDraft />} />
          <Route path="/join/:code" element={<JoinDraft />} />
          <Route path="/draft/:code" element={<DraftRoom />} />
          <Route path="/contest/new" element={<RequireAuth><CreateContest /></RequireAuth>} />
          <Route path="/contest/join" element={<RequireAuth><JoinContest /></RequireAuth>} />
          <Route path="/contest/join/:code" element={<RequireAuth><JoinContest /></RequireAuth>} />
          <Route path="/contest/:code" element={<ContestLobby />} />
          <Route path="/contest/:code/standings" element={<ContestStandings />} />
          <Route path="/login" element={<Login />} />
          <Route path="/auth/verify" element={<AuthVerify />} />
          <Route path="/sso" element={<Sso />} />
          <Route path="/my-contests" element={<RequireAuth><MyContests /></RequireAuth>} />
          <Route path="/help" element={<Help />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <InstallPrompt />
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "hsl(150 65% 16%)",
            color: "hsl(42 38% 95%)",
            border: "1px solid hsl(38 41% 55%)",
            fontFamily: "Inter, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
